import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet-async';
function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert(`Message Sent Successfully!`);
  };

  return (
    <div className='bg-[#FAF3E0] min-h-screen flex flex-col items-center justify-center  py-12'>
      <Helmet>
            <title>Contact Us - Kota HOLDINGS</title>
            <meta name='description' content='A Vision of My 30-Year World' />
            </Helmet>
      <motion.h1
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
        className='text-3xl md:text-4xl font-bold text-[#FF6F00] text-center mb-8'
      >
        Contact Us
      </motion.h1>

      {/* Contact Form */}
      <div className="flex flex-col md:flex-row justify-center items-center gap-12 px-8 py-12 bg-white">
        {/* Address Section */}
        <div className="flex-1  p-2 max-w-lg">
          <h3 className="text-2xl font-bold text-[#FF6F00] mb-4">Address</h3>
          <p className="text-gray-700 text-lg mb-6">
            Feel free to reach out to us at the following address or fill out the form to send us a message.
          </p>
          <div className="space-y-4">
            <div>
              <h4 className="text-lg font-semibold text-gray-800">Address:</h4>
              <p className="text-gray-600">KOTA HOLDINGS <br />Flat #2 & 3, Kota chambers <br></br> GK Towers, Dwarakanagar
              <br/> Visakhapatnam, Andhra Pradesh, 530016</p>
            
            </div>
            <div>
              <h4 className="text-lg font-semibold text-gray-800">Phone:</h4>
              <p className="text-gray-600">+91 9991 577 577</p>
            </div>
            <div>
              <h4 className="text-lg font-semibold text-gray-800">Email:</h4>
              <p className="text-gray-600">venkatareddy.k@kotaholdings.in</p>
            </div>
          </div>

          {/* Google Maps Section */}
          <div className="mt-8">
            <h4 className="text-lg font-semibold text-gray-800 mb-2">Find Us Here:</h4>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3800.394284955396!2d83.3033699!3d17.7260517!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a39433c90779bc9%3A0x1203f2b7b3099c7!2sGK%20Towers%2C%20Dwarakanagar%20Rd%2C%20Sagar%20Nagar%2C%20Dwaraka%20Nagar%2C%20Visakhapatnam%2C%20Andhra%20Pradesh%20530016!5e0!3m2!1sen!2sin!4v1742904766116!5m2!1sen!2sin" 
              width="100%"
              height="300"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              className="rounded-lg shadow-md"
            ></iframe>
          </div>
        </div>

        {/* Form Section */}
        <div className="flex-1  md:p-8 rounded-2xl ">
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label className="block text-lg font-semibold text-gray-700">Name</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Enter your name"
                className="w-full px-4 py-2 border-2 border-[#FF6F00] rounded-lg focus:outline-none focus:ring-2 focus:ring-[#FF6F00]"
                required
              />
            </div>

            <div>
              <label className="block text-lg font-semibold text-gray-700">Email</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Enter your email"
                className="w-full px-4 py-2 border-2 border-[#FF6F00] rounded-lg focus:outline-none focus:ring-2 focus:ring-[#FF6F00]"
                required
              />
            </div>
            <div>
              <label className="block text-lg font-semibold text-gray-700">Phone Number</label>
              <input
                type="phone"
                name="phone number"
                value={formData.phonenumber}
                onChange={handleChange}
                placeholder="Enter your Mobile number"
                className="w-full px-4 py-2 border-2 border-[#FF6F00] rounded-lg focus:outline-none focus:ring-2 focus:ring-[#FF6F00]"
                required
              />
            </div>

            <div>
              <label className="block text-lg font-semibold text-gray-700">Message</label>
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                placeholder="Enter your message"
                className="w-full px-4 py-2 border-2 border-[#FF6F00] rounded-lg focus:outline-none focus:ring-2 focus:ring-[#FF6F00]"
                rows="4"
                required
              ></textarea>
            </div>

            <button
              type="submit"
              className="w-full bg-[#FF6F00] text-white py-2 rounded-lg font-semibold hover:bg-[#e65c00] transition duration-300"
            >
              Send Message
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Contact;
